module.exports = __webpack_public_path__ + "img/pdfs.72a34b29.jpg";